import { BaseData } from 'src/containers/ProjectDiagram/types/data';

export const getPartsKeys = (collection: go.Set<go.Part>) =>
  collection.map((part) => (part.data as BaseData).key).toArray();
